<div class="list-page dashboard-page" data-testid="dashboard-page">
  <header class="dashboard-greeting">
    <span class="dashboard-greeting__avatar" aria-hidden="true">{{ userInitials }}</span>
    <div>
      <h1 class="dashboard-greeting__title">Welcome back, {{ user.firstName }}</h1>
      <p class="dashboard-greeting__subtitle">
        Here's what's moving across your projects today.
      </p>
    </div>
  </header>

  @if (loading) {
    <div class="empty-state" data-testid="dashboard-loading">
      <p class="empty-state__title">Loading your dashboard…</p>
    </div>
  } @else {
    <div class="dashboard-tiles">
      <a
        class="card dashboard-tile"
        routerLink="/invitations"
        data-testid="dashboard-tile-invitations"
      >
        <span class="dashboard-tile__value">{{ kpis.openInvitations }}</span>
        <span class="dashboard-tile__label">Open invitations</span>
      </a>

      <a
        class="card dashboard-tile"
        routerLink="/active"
        data-testid="dashboard-tile-site-visits"
      >
        <span class="dashboard-tile__value">{{ kpis.upcomingSiteVisits }}</span>
        <span class="dashboard-tile__label">Upcoming site visits</span>
      </a>

      <a
        class="card dashboard-tile"
        routerLink="/proposals"
        data-testid="dashboard-tile-atps"
      >
        <span class="dashboard-tile__value">{{ kpis.atpsToSign }}</span>
        <span class="dashboard-tile__label">ATPs to sign</span>
      </a>

      <!-- Receivables due — gated on Spec 11. Kept in the 4-tile grid so the
           layout is final; not a link (nothing to navigate to yet). -->
      <div
        class="card dashboard-tile dashboard-tile--disabled"
        aria-disabled="true"
        data-testid="dashboard-tile-receivables"
      >
        <span class="dashboard-tile__value">—</span>
        <span class="dashboard-tile__label">Receivables due</span>
        <span class="dashboard-tile__badge pill pill--warning">Coming soon</span>
      </div>
    </div>

    <app-work-map [projects]="projects"></app-work-map>

    <section class="card dashboard-activity" data-testid="dashboard-activity">
      <h2 class="dashboard-activity__title">Recent activity</h2>

      @if (activity.length === 0) {
        <div class="empty-state" data-testid="dashboard-activity-empty">
          <p class="empty-state__title">No recent activity.</p>
        </div>
      } @else {
        <ul class="dashboard-activity__list">
          @for (item of activity; track $index; let i = $index) {
            <li
              class="dashboard-activity__row"
              role="button"
              tabindex="0"
              [attr.data-testid]="activityTestIds[i]"
              (click)="onActivityClick(item)"
              (keydown.enter)="onActivityClick(item)"
            >
              @if (item.type === 'ERROR') {
                <span class="material-icons dashboard-activity__error-icon">error</span>
              }
              <div class="dashboard-activity__content">
                <span class="dashboard-activity__subject">{{ item.subject }}</span>
                <span class="dashboard-activity__body">{{ item.body }}</span>
                <span class="dashboard-activity__date">{{
                  item.createdOn | date : 'MM-dd-yyyy hh:mm a'
                }}</span>
              </div>
            </li>
          }
        </ul>
      }
    </section>
  }
</div>
